import { ListItem, ListItemText, Paper, Stack } from "@mui/material";
import React, { useCallback } from "react";

import { useDispatch } from "react-redux";
import UsersPageModal from "../users-page-modal";
import { usersPageSetModal } from "../reducers/users-page-actions";
import OptionsMenu from "../../../../extra-components/options-menu";
import { Body1, Body2 } from "../../../../components";

const STR = {
  labelEdit: "EDITAR",
  labelDelete: "EXCLUIR",
  infoValue: "Valor",
};

function GlobalVariableItem({ id, name, value, description }) {
  return (
    <Paper sx={{ my: 0.5 }}>
      <ListItem
        secondaryAction={
          <Options
            id={id}
            name={name}
            value={value}
            description={description}
          />
        }
      >
        <ListItemText
          primary={name}
          secondary={<SecondaryInfo description={description} value={value} />}
        />
      </ListItem>
    </Paper>
  );
}

const SecondaryInfo = ({ description, value }) => {
  return (
    <Stack gap={1.5}>
      <Body2>{description}</Body2>
      <Body1
        fontWeight="bold"
        sx={{ color: ({ palette }) => palette.primary.main }}
      >
        {STR.infoValue}: {value}
      </Body1>
    </Stack>
  );
};

const Options = ({ id, name, value, description }) => {
  const dispatch = useDispatch();
  //
  const onDelete = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_GLOBAL_DELETE,
        data: id,
      })
    );
  }, [dispatch, id]);
  //
  const onEdit = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_GLOBAL_EDIT,
        data: {
          id,
          name,
          description,
          value,
        },
      })
    );
  }, [dispatch, value, id, name, description]);
  //
  const options = [
    {
      icon: "Edit",
      label: STR.labelEdit,
      onClick: onEdit,
    },

    {
      icon: "Delete",
      label: STR.labelDelete,
      onClick: onDelete,
    },
  ];
  return <OptionsMenu options={options} />;
};

export default GlobalVariableItem;
